function findObjectByKey(array, key, value, multiple) {
  try {
    let rtn = [];
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        if ( multiple ) {
          rtn.push( array[i] );
        } else {
          return array[i];
        }
      }
    }
    if ( multiple && rtn.length > 0 ) {
      return rtn;
    } else {
      return null;
    }
  }
  catch ( err ) {
    console.log( `ERROR findObjectByKey`, err.message );
  }
}

function ElementAvailibility ( selectorIs, functionName, timer, args='' ) {
  try {
    var divCheckingInterval                   =   setInterval( function() {
      if ( document.querySelector( selectorIs ) ) {
        clearInterval( divCheckingInterval );
        if ( typeof functionName !== 'undefined' && functionName ) {
          window[functionName]( args ? args : '' );
        }
        return true;
      }
    }, timer != '' ? timer : 250);
    return false;
  } catch ( err ) {
    console.log( `ERROR checkingElement`, err.message );
  }
}

function incrementalQty( this_ ) {
  try {
    const qty = $( `product-page product-form product-quantity [name="quantity"]` ).val() * 1;
    const min = $( `product-page product-form product-quantity [name="quantity"]` ).attr( `min` ) * 1;
    console.log ( 'qty', qty, min );
  } catch ( err ) {
    console.log( `ERROR incrementalQty`, err.message );
  }
}

function decrimentalQty( this_ ) {
  try {
    const qty = $( `product-page product-form product-quantity [name="quantity"]` ).val() * 1;
    const min = $( `product-page product-form product-quantity [name="quantity"]` ).attr( `min` ) * 1;

    if ( typeof qty !== 'undefined' && qty && typeof min !== 'undefined' && min ) {
      if ( qty < min ) {
        $( `product-page product-form product-quantity` ).addClass( `error` );

        setTimeout(() => {
          $( `product-page product-form product-quantity` ).removeClass( `error` );
        }, 5000);
      }
    }
  } catch ( err ) {
    console.log( `ERROR decrimentalQty`, err.message );
  }
}

function decrimentalQtyCart( this_ ) {
  try {
    const qtyCart = $( this_ ).closest( `.cart-item` ).find( `product-quantity [name="updates[]"]` ).val() * 1;
    const minCart = $( this_ ).closest( `.cart-item` ).find( `product-quantity [name="updates[]"]` ).attr( `min` ) * 1;

    if ( typeof qtyCart !== 'undefined' && qtyCart && typeof minCart !== 'undefined' && minCart ) {
      console.log ( 'qtyCart', qtyCart );
      if ( qtyCart <= minCart ) {
        $( this_ ).closest( `.cart-item` ).find( `product-quantity` ).addClass( `error` );

        setTimeout(() => {
          $( this_ ).closest( `.cart-item` ).find( `product-quantity` ).removeClass( `error` );
        }, 5000);
      }
    }
  } catch ( err ) {
    console.log( `ERROR decrimentalQty`, err.message );
  }
}


function checkQtyValidation(this_) {
  try {
    let typingTimer;
    const typingDelay = 700;
    clearTimeout(typingTimer);
    typingTimer = setTimeout(function () {
      let qtyCart = $( this_ ).val() * 1;
      let minCart = $( this_ ).attr( `min` ) * 1;
      let _bckvalue = $( this_ ).attr( `data-value` ) * 1;
        
      var CartType = 0;
      if($( this_ ).hasClass(`_cart__quantity`)){
        CartType = 1;
      }
      
      var _bckval = qtyCart > minCart ? qtyCart : minCart;
       //console.log (this_, 'qtyCart', qtyCart , 'minCart================= _bckvalue, minCart: ',_bckvalue, minCart ,qtyCart < minCart);

      if ( (qtyCart == minCart || qtyCart == _bckvalue) && _bckvalue == minCart){
        
          //console.log("no action")  
          //console.log("reach")
        //_updateQty(this_,_bckval);
      }else if ( qtyCart == _bckvalue ) {
        //console.log("no action _bckvalue")  
      }else if ( qtyCart < minCart ) {
        //console.log("0")
        $( this_ ).closest( `product-quantity` ).addClass( `error` );
        $( this_ ).closest( `.customQtyFile__wrapper` ).addClass( `error` );
        $( this_ ).css( `color`, `#d00` );
        $(this_).val(_bckval);  
        _updateQty(this_,_bckval)
        
        setTimeout(() => {
          $( this_ ).closest( `product-quantity` ).removeClass( `error` );
           $( this_ ).closest( `.customQtyFile__wrapper` ).removeClass( `error` );
          $( this_ ).css( `color`, `#000` );
        }, 8000);
        
      }else{
        //console.log("1")
        $( this_ ).closest( `product-quantity` ).removeClass( `error` );
         $( this_ ).closest( `.customQtyFile__wrapper` ).removeClass( `error` );
        $( this_ ).css( `color`, `#000` );
        _updateQty(this_,_bckval)
        setTimeout(() => {
          $( this_ ).closest( `product-quantity` ).removeClass( `error` );
          $( this_ ).closest( `.customQtyFile__wrapper` ).removeClass( `error` );
        }, 8000);
      }
    }, typingDelay);
  } catch ( err ) {
    console.log( `ERROR checkQtyValidation`, err.message );
  } 
}

/*
function checkQtyValidation(this_) {
  try {
    let typingTimer;
    const typingDelay = 500;
    clearTimeout(typingTimer);
    typingTimer = setTimeout(function () {
      let qtyCart = $( this_ ).val() * 1;
      let minCart = $( this_ ).attr( `min` ) * 1;
      let _bckvalue = $( this_ ).attr( `data-value` ) * 1;
        
      var CartType = 0;
      if($( this_ ).hasClass(`_cart__quantity`)){
        CartType = 1;
      }
      
      var _bckval = qtyCart > minCart ? qtyCart : minCart;
       console.log (this_, 'qtyCart', qtyCart , 'minCart================= _bckvalue, minCart: ',_bckvalue, minCart ,qtyCart < minCart);

      if ( qtyCart == minCart || qtyCart == _bckvalue ){
        console.log("reach")
      }else if ( qtyCart < minCart ) {
          $( this_ ).closest( `product-quantity` ).addClass( `error` );
          $( this_ ).css( `color`, `#d00` );
          $(this_).val(_bckval);  
          _updateQty(this_,_bckval)
          
          setTimeout(() => {
            $( this_ ).closest( `product-quantity` ).removeClass( `error` );
            $( this_ ).css( `color`, `#000` );
          }, 5000);
          
        }else{
          $( this_ ).closest( `product-quantity` ).removeClass( `error` );
          $( this_ ).css( `color`, `#000` );
          _updateQty(this_,_bckval)
          setTimeout(() => {
            $( this_ ).closest( `product-quantity` ).removeClass( `error` );
          }, 5000);
        }
    }, typingDelay);
  } catch ( err ) {
    console.log( `ERROR checkQtyValidation`, err.message );
  } 
}
*/


function _updateQty(node,_bckval) {
    if($(node).hasClass("customQtyFile__qty")){
      
    }else{
    var nwVal = _bckval + 1;
     $(node).val(nwVal).attr("data-value",(nwVal-1));
     $(node).closest( `product-quantity` ).find(`._cart__quantity`).val(nwVal-1);
   }    
     $(node).closest( `product-quantity` ).find(`.qty-button.qty-minus`).click();
      
    $(node).css( `color`, `#000` );
}


function cartStickyFunc() {
  if($(window).outerHeight() > 800){
    $("#site-cart-sidebar").addClass("enable_cart_sticky");
  }else{
    $("#site-cart-sidebar").removeClass("enable_cart_sticky");
  }
}

if ( typeof errMsg == 'undefined' ) {
  errMsg = `<div class="error_color __uploaderror"><span><img src="https://cdn.shopify.com/s/files/1/0558/0265/8899/files/warning_icon_red.svg?v=1725642417" alt="error" /></span> Mandatory field!</div>`;
}

window.addEventListener('upload:added', function(e) {
  $("[data-upload-lift]").removeClass("error-box-wrapper").find(".error_color").remove();
})

window.addEventListener('upload:removed', function(e) {
  $("[data-upload-lift]").removeClass("error-box-wrapper").find(".error_color").remove();
})

$(function () {
  cartStickyFunc();
  $(window).resize(function(){
    cartStickyFunc();
  });
  $(document).on("click",".hidebox",function () {
    $(this).remove();
  })
  var _clicked = 0;
  $(".cta-wrapper-box:not(.validated)").click(function(){
    //console.log("click happend");
    formValidation();
  })

  $(document).on("change input blur",'product-form.product-form input[type=radio][required],product-form.product-form input:not(:hidden)[required],product-page input[type=file]',function () {
    var _currObj = $(this);
    var _radioName = _currObj.attr("name");
    if($("input[name='" + _radioName + "']:checked").length > 0){
      _currObj.parents(".selector-wrapper").find(".error_color").remove();
    }

    _isvalid = mutedcheck();
    if(_isvalid == true){
      $(".error_color,._error_block").remove();
      $(".cta-wrapper-box").addClass("validated");
      if($(".anotherTransfer").length){
        $(".anotherTransfer").removeClass("disabled");
        $(".second-upload-cta").removeClass("disabled");
      }
    }else{
      if($(".anotherTransfer").length){
      //  $(".anotherTransfer").addClass("disabled");
      //  $(".second-upload-cta").addClass("disabled");
      }
    }
  })

  $(document).on("keyup",'product-form.product-form input[type=text][required]',function () {
    var _currObj = $(this);
    if(_currObj.val() != ""){
      _currObj.parents(".selector-wrapper").find(".error_color").remove();
    }
    _isvalid = mutedcheck();
    if(_isvalid == true){
      $(".error_color,._error_block").remove();
      $(".cta-wrapper-box").addClass("validated");
    }
  })
})

function mutedcheck() {
  var _isvalid = true;
  var _form_file = $("product-page").find("input[type=file]");

  if(_form_file.length > 0){  
        if($("[name='properties[Upload]']").length > 0){
          
        }else{
          _isvalid = false;
        } 
  }

  var _nodlist = $("product-form.product-form").find("input[type=text][required]");
  if(_nodlist.length){
    for(var i=0; i < _nodlist.length; i++){
      if($(_nodlist[i]).val() == ""){
        _isvalid = false;
      }
    }
  }


  var _nodlist = $("product-form.product-form").find(".qtyselector");
  if(_nodlist.length){
    for(var i=0; i < _nodlist.length; i++){
      var minl = $(_nodlist[i]).attr("min") * 1;
      if($(_nodlist[i]).val() < minl){
       // _isvalid = false;
      }
    }
  }
  
  var _nodlist = $("product-form.product-form").find("input[type=radio][required]");
  for(var i=0; i < _nodlist.length; i++){
    var radioName = $(_nodlist[i]).attr("name");
    _currObj = $(_nodlist[i]);
    if ($("product-form.product-form input[name='" + radioName + "']:checked").length == 0) {
      _isvalid = false;
    }
  }
  const checkHeightOfInput = $( `.customVariantWidget__item[block-type="height"] height-ele .inputEle` );
  if ( checkHeightOfInput.length > 0 ) {
    if ( checkHeightOfInput.val() == '' ) {
    //  _isvalid = false;
    }
  }
  //console.log("_isvalid: ",_isvalid)
  return _isvalid;
}

function formValidation() {
    $(".error_color,._error_block").remove();
    var _iserror = 0;

    var _form_input = $("product-form.product-form").find("input[required]");
    //var _form_area = $("product-form.product-form").find("textarea[required]");
    var _form_area = $("product-form.product-form").find(".cl-upload--input----");
    var _form_file = $("product-form.product-form").find("input[type=file]");
    const checkHeightOfInput = $( `.customVariantWidget__item[block-type="height"] height-ele .inputEle` );

    if(_form_file.length > 0){
      $(".error_color").remove();
      if($(_form_file).parents("[data-upload-field]")){
        nodeparent = $(_form_file).parents("[data-upload-lift]");
        if($(nodeparent).find("[name='properties[Upload]']").length > 0){
          //console.log("_iserror: ",_iserror)
        }else{
          _iserror = 1;
          if(nodeparent.length){
            //console.log(nodeparent," :nodeparent")
            var _topPos = nodeparent.position().top;
            $(nodeparent).addClass("error-box-wrapper");
          //  $('html, body').animate({scrollTop:_topPos});
            $(nodeparent).find(".cl-upload--area").after(`<div class="error_color __uploaderror""><span><img src="https://cdn.shopify.com/s/files/1/0558/0265/8899/files/warning_icon_red.svg?v=1725642417" alt="error" /></span> Please upload the file to continue</div>`);
            return;
          }
        }
      }
    }

    if(_form_area.length > 0){
      for(var _i=0; _i < _form_area.length; _i++){
        var _node = $(_form_area[_i]);
        var _input_value = _node.val();
          if(_input_value == ""){
            _iserror = 1;
            _node.focus();
            _node.parents(".cl-upload--input-fields").append(`${ errMsg }`);
            return;
          }
      }
    }

    var _namelist = [];
    var _k = 0;
    for(var _i=0; _i < _form_input.length; _i++){
      var _name = $(_form_input[_i]).attr("name");
      if(_namelist.indexOf(_name) < 0){
        _namelist[_k++] = _name;
      }
    }

    for(var _i=0; _i < _namelist.length; _i++){
      if($("input[name='"+_namelist[_i]+"']").is(":visible")){
        _iserror = validate($("input[name='"+_namelist[_i]+"']"));
        var _node = $("input[name='"+_namelist[_i]+"']");
        if(_iserror == 1){
          _node.focus();
          parent_node = _node.parents(".selector-wrapper");
          return;
        }
      }
    }

    if ( checkHeightOfInput.length > 0 ) {
      if ( checkHeightOfInput.val() == '' ) {
        _iserror = 1;
        $( `.customVariantWidget__item[block-type="width"] info` )
          .after( `<div class="error_color __uploaderror" style="white-space: nowrap;"><span><img src="https://cdn.shopify.com/s/files/1/0558/0265/8899/files/warning_icon_red.svg?v=1725642417" alt="error"></span>Please Enter your desired height</div>` );

      //  $( `html, body` ).animate({scrollTop: $( `.customVariantWidget` ).offset().top-90});
        return;
      }
    }

    if(_iserror == 0){
      $(".cta-wrapper-box").addClass("validated");
    }
}


function validate(_node) {
  var iserror = 0;
    $(".error_color,._error_block").remove();

      var _inputType = _node.attr("type");
      //console.log(_inputType," :_inputType",_node);
      switch(_inputType){
        case "radio":
        case "checkbox":
          
          if(_node.is(":checked") == false){
            var nodeparent = _node.parents(".selector-wrapper");
            nodeparent.find(".error_color").remove();
            var _topPos = nodeparent.position().top;
            $('html, body').animate({scrollTop:_topPos},500);
             nodeparent.append(`${ errMsg }`)
            iserror = 1;
          }
          break;
        case "file":
          var _parentNode = $(_node).parents("[data-upload-field]");
          if(_parentNode){
            if(_parentNode.find("properties[Upload]"))
            var _input_value = _node.val();
            if(_input_value == ""){
              iserror = 1;
              _node.focus();
               $(_node).parents(".selector-wrapper").append(`${ errMsg }`);
            }
          }
          break;
        case "text":
          var _input_value = _node.val();
          if(_input_value == ""){
            _node.focus();
            _node.parents(".selector-wrapper").append(`${ errMsg }`);
            iserror = 1;
          }
          break;
      }
  return iserror;
}


var addDelay = ms => new Promise(res => setTimeout(res, ms));

function toast( title, msg, color='green', timer=5000 ) {
  try {
  //$( `.toast` ).remove();
  $( `body` ).append( `<div class="toast ${ color }">
  <div class="toast-content">
    <svg class="fas fa-solid fa-check check" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/></svg>
    <div class="message">
      <span class="text text-1">${ title }</span>
      <span class="text text-2">${ msg }</span>
    </div>
    </div>
    <svg class="fa-solid fa-xmark close" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L18 18" stroke="#000" stroke-linecap="round"></path><path d="M18 6L6.00001 18" stroke="#000" stroke-linecap="round"></path></svg>
    <div class="progress active"></div></div>` );
    setTimeout(() => {
      $( `.toast` ).addClass( `active` );
    }, 50);
    setTimeout(() => {
      $( `.toast` ).removeClass( `active` );
    }, timer);
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

/*** Free approval logic **/
document.addEventListener("DOMContentLoaded", function() {
    rmproductcart();
})

function removeProcuct(productVids,callback) {
  let variantsToRemove = productVids; // Add the variant IDs you want to remove
    let updates = {};
    variantsToRemove.forEach(variantId => {
        updates[variantId] = 0;
    });

      fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .then(() => {
          fetch('/?sections=cart-items,cart-footer')
          .then(response => response.json())
          .then(data => {
            
              window.refreshCart();
              reCalculateFreeShippingModule();
              if (typeof callback === 'function') {
                callback();
              }
          });
      });
}


  async function reCalculateFreeShippingModule() {
    try {
      for (let i = 1; i <= 5; i++) {
        await addDelay( 1000 );
        reCalculateFreeShippingModule__recall();
      }
    } catch ( err ) {
      console.log( `ERROR reCalculateFreeShippingModule`, err.message );
    }
  }

  function reCalculateFreeShippingModule__recall() {
    try {
      const freeShippingBysize = $( `free-shipping-bysize` );
      const freeShippingBlanks = $( `free-shipping-blanks` );
      if ( freeShippingBysize.length > 0 ) {
        const mainAmount = freeShippingBysize.attr( `free-shipping-amount` ) * 1;
        const completedAmount = freeShippingBysize.attr( `data-cart-total` ) * 1;
        const percentage = ( completedAmount / mainAmount ) * 100;
        if ( percentage <= 100 ) {
          freeShippingBysize.find( `.cart-notice__slider-bar` ).css( `width`, `${ percentage }%` );
        } else {
          freeShippingBysize.find( `.cart-notice__slider-bar` ).css( `width`, `100%` );
        }
      }
      if ( freeShippingBlanks.length > 0 ) {
        const mainAmount = freeShippingBlanks.attr( `free-shipping-amount` ) * 1;
        const completedAmount = freeShippingBlanks.attr( `data-cart-total` ) * 1;
        const percentage = ( completedAmount / mainAmount ) * 100;
        if ( percentage <= 100 ) {
          freeShippingBlanks.find( `.cart-notice__slider-bar` ).css( `width`, `${ percentage }%` );
        } else {
          freeShippingBlanks.find( `.cart-notice__slider-bar` ).css( `width`, `100%` );
        }
      }
    } catch ( err ) {
      console.log( `ERROR `, err.message );
    }
  }



function rmproductcart() {
  var p = $("cart-form").parents(".cart-section")
  if(p.length > 0 && $(".eligibilityFreeApproval").length){
    var isexist = $(".eligibilityFreeApproval").attr("data-productincart");
    var free_approval_status = $(".eligibilityFreeApproval").attr("data-free_approval_status");
    var rmfreegift = $(".eligibilityFreeApproval").attr("data-rmfreegift")
    var freevid = $(".eligibilityFreeApproval").attr("data-freevid") * 1;
    var paidvid = $(".eligibilityFreeApproval").attr("data-paidvid") * 1;
    
    //console.log(isexist,free_approval_status,rmfreegift)
    if(isexist == "false" && free_approval_status == "true"){
      
      var _pid = $(".eligibilityFreeApproval").attr("data-freepid");
      $("#data-js-cart-wrapping-checkbox").addClass("approval_status").attr({"vid":freevid,"pid":$(".eligibilityFreeApproval").attr("data-freepid")})
      $("#data-js-cart-wrapping-checkbox [name=product-id]").val(_pid);
      setTimeout(function(){
        if(rmfreegift == "true"){
          var arr = [];
          arr.push(paidvid);
          removeProcuct(arr);
        }else{
          document.querySelector(".approval_status .yes").click();
        }
      })
    }else if(isexist == "true" && free_approval_status == "false"){
      var arr = [];
      arr.push(freevid);
      if(rmfreegift == "true"){
        arr.push(paidvid);
      }
      removeProcuct(arr);
      var _pid = $(".eligibilityFreeApproval").attr("data-paidpid");
      $("#data-js-cart-wrapping-checkbox").removeClass("approval_status").attr({"vid":paidvid,"pid":$(".eligibilityFreeApproval").attr("data-paidpid")})
      $("#data-js-cart-wrapping-checkbox [name=product-id]").val(_pid)
    }else if(isexist == "true" && free_approval_status == "true"){
      $("#cart-gift-wrapping").attr("checked",true);
      $("#data-js-cart-wrapping-checkbox").addClass("approval_status");
    }else{
      var _pid = $(".eligibilityFreeApproval").attr("data-paidpid");
      $("#data-js-cart-wrapping-checkbox").removeClass("approval_status").attr({"vid":paidvid,"pid":$(".eligibilityFreeApproval").attr("data-paidpid")})
      $("#data-js-cart-wrapping-checkbox [name=product-id]").val(_pid)
    }
    reCalculateFreeShippingModule();
  }else{
  }
}
/*** ./Free approval logic **/

$(function () {

  if($(window).outerWidth() > 768){
    $(window).on("load",function (params) {
      //console.log($(".bcpo-jumbo-swatches:visible"), ":bcpo-images");
      var style = '<style>';
      var _swatch = $(".bcpo-jumbo-swatches");
      for(var k=0; k < _swatch.length; k++){
        var _title = $.trim($(_swatch).eq(k).parents(".bcpo-images").find(".bcpo-title").text());
        title = $.trim(_title.replace("Select","").replace(":",""));
        //console.log($.trim(title)," =====title==== ",_title);
        if(title != "Shape--"){
          //console.log($(_swatch[k]),"_swatch[k]")
          var _imglableList = $(_swatch[k]).find(".bcpo-front-image-label");
          for(var i = 0; i < _imglableList.length; i++){
            $(_imglableList[i]).addClass("hover-effect hoverindex"+k+i).attr("data-css","hoverindex"+k+i);
            var imageUrl = $(_imglableList[i]).css('background-image').replace(/url\(['"]?(.*?)['"]?\)/, '$1');
            imageUrl = imageUrl.replace(/url\(['"]?(.*?)['"]?\)/, '$1');
            $(_imglableList[i]).attr("data-src",imageUrl);
            $(_imglableList[i]).find('::after').css('background', imageUrl);
            style += '.hoverindex'+k+i+'::after{background:url("' + imageUrl + '");}';
          }
        }
      }
      style += '</style>';
      $(style).appendTo('head');
    })

    $(document).on('mousemove', ".hover-effect", function(event) {
      
        $("#tempstyle").remove();
    
        const elemWidth = elemHeight = 250;
        const viewportWidth = $(window).width();
        const viewportHeight = $(window).height();
        const _cssname = $(this).attr("data-css");
    
        // Get the parent element's offset
        const parentOffset = $(this).offset();
        var _top = event.clientY;
    
        // Calculate cursor position relative to the parent element
        let posX = event.pageX - parentOffset.left + 5;
        let posY = event.pageY - parentOffset.top + 5;
    
        // Adjust position based on available space (top or bottom)
        if (posY + elemHeight > viewportHeight) {
            // Not enough space at the bottom, position at the top
            posY = event.pageY - parentOffset.top - elemHeight - 5;
        }
        if (posY < 0) {
            // Not enough space at the top, revert to bottom
            posY = event.pageY - parentOffset.top + 5;
        }
    
        // Adjust position based on available space (left or right)
        if (posX + elemWidth > viewportWidth) {
            // Not enough space on the right, position to the left
            posX = event.pageX - parentOffset.left - elemWidth - 5;
        }
        if (posX < 0) {
            // Not enough space on the left, revert to right
            posX = event.pageX - parentOffset.left + 5;
        }
    
         var sytleVal = ``;
         if((_top + elemWidth) < viewportHeight){
           sytleVal = 'bottom:auto; top:calc(100% + 8px)';
         }
         //console.log((_top + elemWidth) > viewportHeight,sytleVal,posX + elemWidth,viewportHeight,posX);
    
        // Create the dynamic CSS for the ::after element
        const style = `
            <style id="tempstyle">
                div#bcpo.bcpo label.bcpo-front-image-label.hover-effect.${_cssname}:after{ ${sytleVal} } 
            </style>`;
        $(style).appendTo('head');
    });
  }
})